<script setup>
import {ref, computed, nextTick} from 'vue';
import YTCard from "@/components/YTCard/newIndex.vue";
import YTAvatarUpload from "@/components/YTAvatarUpload/index.vue";

const props = defineProps({
  // 是否编辑状态
  isReadMode: {
    type: Boolean,
    default: false
  },
  // 双向绑定值
  modelValue: {
    required: true,
    type: Object,
  },
})

const emit = defineEmits(['success'])
// 是否编辑模式
const isEdit = ref(false)
// 加载状态
const loading = ref(false)
// 处理人员头像反显
const handleReviewPersonnelInfoUploadPic = (reviewList) => {
  boxUploadAvatarRef.value.forEach((item, index) => {
    if (reviewList[index]?.avatar) {
      item.handleReview([reviewList[index]?.avatar])
    } else {
      item.handleClearList()
    }
  })
}
// 人员头像锚点
const boxUploadAvatarRef = ref([])
// 处理主理人信息头像上传成功
const handlePersonnelAvatarSuccess = (url, index) => {
  console.log(`第${index + 1}个人员头像上传成功`);
  // 更新表单数据
  if (!ruleForm.value.personnelInfo[index]) {
    ruleForm.value.personnelInfo[index] = {
      avatar: null,
      name: null,
      nameEn: "Coming Soon ...",
      summaryInfo: [
        {
          summary: null,
          summaryEn: "Coming Soon ...",
        },
      ],
    };
  }
  ruleForm.value.personnelInfo[index].avatar = url[0];
  ruleFormRef.value.validateField("personnelInfo.avatar");
  loading.value = false;
}
// 处理主理人信息头像删除
const handlePersonnelAvatarRemove = (url, index) => {
  ruleForm.value.personnelInfo[index].avatar = url[0];
  ruleFormRef.value.validateField("personnelInfo.avatar");
}
// 俱乐部人员头像校验规则
const checkPersonnelAvatar = (rule, value, callback) => {
  for (let i = 0; i < ruleForm.value.personnelInfo.length; i++) {
    console.log("[i]", i);
    console.log("ruleForm.personnelInfo[i]", ruleForm.value.personnelInfo[i]);
    if (
        !ruleForm.value.personnelInfo[i].avatar &&
        !boxUploadAvatarRef.value[i].isChange
    ) {
      return callback(new Error(`主理人信息中第${i + 1}项人员头像未上传`));
    }
  }
  return callback();
};
// 俱乐部人员名称校验规则
const checkPersonnelName = (rule, value, callback) => {
  for (let i = 0; i < ruleForm.value.personnelInfo.length; i++) {
    if (!ruleForm.value.personnelInfo[i].name) {
      console.log(
          "ruleForm.personnelInfo[i].name",
          ruleForm.value.personnelInfo[i].name
      );
      return callback(
          new Error(`主理人信息中第${i + 1}项人员名称（中文）未填写`)
      );
    }
    if (!ruleForm.value.personnelInfo[i].nameEn) {
      return callback(
          new Error(`主理人信息中第${i + 1}项人员名称（English）未填写`)
      );
    }
  }
  return callback();
};
// 俱乐部人员简介校验规则
const checkSummaryInfo = (rule, value, callback) => {
  for (let i = 0; i < ruleForm.value.personnelInfo.length; i++) {
    for (let j = 0; j < ruleForm.value.personnelInfo[i].summaryInfo.length; j++) {
      if (!ruleForm.value.personnelInfo[i].summaryInfo[j].summary) {
        return callback(
            new Error(
                `主理人信息中第${i + 1}项的第${j + 1}人员简介（中文）未填写`
            )
        );
      }
      if (!ruleForm.value.personnelInfo[i].summaryInfo[j].summaryEn) {
        return callback(
            new Error(
                `主理人信息中第${i + 1}项的第${j + 1}人员简介（English）未填写`
            )
        );
      }
    }
  }
  return callback();
};
// 默认校验规则
const rulesOne = {
  personnelInfo: {
    avatar: [
      { required: true, validator: checkPersonnelAvatar }
    ],
    name: [
      { required: true, validator: checkPersonnelName, trigger: "change" },
    ],
    summaryInfo: [
      { required: true, validator: checkSummaryInfo, trigger: "change" },
    ],
  }
}
// 表单校验规则
const rules = ref(rulesOne)

/*增加人员相关*/
// 增加人员
const handleAddMember = () => {
  if (ruleForm.value.personnelInfo.length >= 3) {
    return ElMessage.error("最多添加三人！")
  }
  ruleForm.value.personnelInfo.push({
    avatar: null,
    name: null,
    nameEn: "Coming Soon ...",
    summaryInfo: [
      {
        summary: null,
        summaryEn: "Coming Soon ..."
      }
    ]
  })
}
// 增加人员简介
const handleAddDesc = (item) => {
  if (item.summaryInfo.length >= 3) {
    return ElMessage.error("人员简介最多三条")
  }
  item.summaryInfo.push({
    summary: null,
    summaryEn: "Coming Soon ..."
  })
}
// 删除人员简介
const handleRemoveSummary = (index, sonIndex) => {
  ruleForm.value.personnelInfo[index].summaryInfo.splice(sonIndex, 1)
}
// 删除人员信息
const handleRemovePersonnelInfo = (index) => {
  ruleForm.value.personnelInfo.splice(index, 1)
  nextTick(() => {
    // 反显人员头像
    handleReviewPersonnelInfoUploadPic(ruleForm.value.personnelInfo)
  })
}
/*表单相关*/
// 表单锚点
const ruleFormRef = ref()
// 表单信息，实现「双向绑定」
const ruleForm = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val)
})
// 保存校验表单
const submit = async () => {
  try {
    if (ruleForm.value.personnelInfo.length <= 0) {
      return ElMessage.error("至少添加一条主理人信息");
    }
    ruleFormRef.value.validate(async (valid) => {
      if (valid) {
        loading.value = true;
        emit("success")
        console.log("ruleForm", ruleForm);
      } else {
        ElMessage({
          message: "请根据提示修改表单信息",
          type: "error",
        });
      }
      loading.value = false;
    });
  } catch (e) {
    console.log(e);
    loading.value = false;
  }
};

/*中英文切换输入框相关Tab*/
// 人员名称tab
const memberAvatarTab = ref(["zh", "zh", "zh"])
// 人员简介tab
const memberDescTab = ref([["zh", "zh", "zh"], ["zh", "zh", "zh"], ["zh", "zh", "zh"]])

defineExpose({
  handleReviewPersonnelInfoUploadPic
})
</script>

<template>
  <div class="personal_wrapper">
    <YTCard :title="`主理人信息`">
      <template #container>
        <el-form
            ref="ruleFormRef"
            :model="ruleForm"
            :rules="rules"
            style="height: 100%;width: 100%;"
            class="flex"
            size="large"
        >
          <div>
            <div v-for="(item, index) in ruleForm.personnelInfo" :key="`personnelInfo${index}`">
              <el-form-item label="人员头像：" prop="personnelInfo.avatar">
                <!--  这里需要改上传方式  -->
                <div class="flex_align_t">
                  <!--                  <BoxUpload :ali-oss-path="'PERSONNEL_INFO_AVATAR_PATH'" :ref="el => { if (el) boxUploadAvatarRef[index] = el }" :width="80" :height="80" :limit="1" :file-size="1" @progress="loading = true" @success="(url) => handlePersonnelAvatarSuccess(url, index)" @remove="(url) => handlePersonnelAvatarRemove(url, index)"></BoxUpload>-->
                  <YTAvatarUpload :ali-oss-path="'PERSONNEL_INFO_AVATAR_PATH'"
                      :isReplaceMode="true"
                      :ref="
                          (el) => {
                            if (el) boxUploadAvatarRef[index] = el;
                          }
                        "
                      :isLogoMode="false"
                      :limit="1"
                      :width="80"
                      :height="80"
                      :file-size="1"
                      :isRequired="true"
                      :tips="``"
                      @progress="loading = true"
                      @success="
                          (url) => handlePersonnelAvatarSuccess(url, index)
                        "
                      @remove="
                          (url) => handlePersonnelAvatarRemove(url, index)
                        "
                  ></YTAvatarUpload>
                  <div class="mg_l_2">
                    <el-tooltip
                        class="box-item"
                        effect="dark"
                        content="删除该人员信息"
                        placement="right">
                      <v-icon class="cursor-pointer" color="error" icon="mdi-close" @click="handleRemovePersonnelInfo(index)"></v-icon>
                    </el-tooltip>
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="人员名称：" prop="personnelInfo.name">
                <el-tabs
                    v-model="memberAvatarTab[index]"
                    type="card"
                    class="demo-tabs"
                >
                  <el-tab-pane label="中文" name="zh">
                    <el-input style="width: 500px" show-word-limit v-model="item.name" placeholder="人员名称"></el-input>
                  </el-tab-pane>
                  <el-tab-pane label="English" name="en">
                    <el-input style="width: 500px" show-word-limit v-model="item.nameEn" placeholder="Detailed addresses, such as street house numbers"></el-input>
                  </el-tab-pane>
                </el-tabs>
              </el-form-item>
              <el-form-item label="人员简介：" prop="personnelInfo.summaryInfo">
                <div>
                  <div class="flex_align_b">
                    <div>
                      <el-tabs
                          v-model="memberDescTab[index][sonIndex]"
                          type="card"
                          class="demo-tabs mg_r_1 mg_b_2"
                          v-for="(sonItem, sonIndex) in item.summaryInfo"
                          :key="`summaryInfo${index}${sonIndex}`"
                      >
                        <el-tab-pane label="中文" name="zh">
                          <div class="flex_left">
                            <el-input style="width: 500px" show-word-limit maxlength="40" v-model="sonItem.summary" placeholder="一般填写在俱乐部的角色"></el-input>
                            <div class="mg_l_1">
                              <el-tooltip
                                  class="box-item"
                                  effect="dark"
                                  content="删除人员简介"
                                  placement="right">
                                <v-icon v-if="item.summaryInfo.length > 1" class="cursor-pointer" color="error" icon="mdi-close" @click="handleRemoveSummary(index, sonIndex)"></v-icon>
                              </el-tooltip>
                            </div>
                          </div>
                        </el-tab-pane>
                        <el-tab-pane label="English" name="en">
                          <div class="flex_left">
                            <el-input style="width: 500px" show-word-limit maxlength="40" v-model="sonItem.summaryEn" placeholder="Detailed addresses, such as street house numbers"></el-input>
                            <div class="mg_l_1">
                              <el-tooltip
                                  class="box-item"
                                  effect="dark"
                                  content="删除"
                                  placement="right">
                                <v-icon v-if="item.summaryInfo.length > 1" class="cursor-pointer" color="error" icon="mdi-close" @click="handleRemoveSummary(index, sonIndex)"></v-icon>
                              </el-tooltip>
                            </div>
                          </div>
                        </el-tab-pane>
                      </el-tabs>
                    </div>
                  </div>
                  <div>
                    <v-btn
                        rounded="xl"
                        color="#ECECF4"
                        @click="handleAddDesc(item)"
                    >
                      <template v-slot:default>
                        <div class="flex_bt">
                          <span style="color: #6f717d">新增介绍</span>
                          <img
                              style="
                                width: 14px;
                                height: 14px;
                                margin-left: 4px;
                              "
                              src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/common/common/plus_gray.svg"
                          />
                        </div>
                      </template>
                    </v-btn>
                  </div>
                </div>
              </el-form-item>
              <el-divider></el-divider>
            </div>
          </div>
        </el-form>
        <div class="flex mg_b_2">
          <div class="flex cursor-pointer" @click="handleAddMember">
            <img
                style="width: 25px; height: 25px; margin-right: 11px"
                src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/createClub/add_member.svg"
            />
            <div class="add_member_tips_member">
              增加成员({{ ruleForm.personnelInfo.length }}/3)&emsp;
            </div>
          </div>
          <div class="add_member_tips">最多可添加3名成员</div>
        </div>
        <div v-if="!props.isReadMode || isEdit">
          <v-row>
            <v-col>
              <v-btn color="primary" @click="submit">保存</v-btn>
            </v-col>
          </v-row>
        </div>
      </template>
    </YTCard>
  </div>
</template>

<style lang="scss" scoped>
.personal_wrapper {
  background-color: #fff;
  box-sizing: border-box;
  padding-bottom: 20px;
}
</style>
